<template>
  <div class="toggleContainer">
    <button
      class="button--toggle left"
      :class="selected === 'left' ? 'active' : ''"
      @click="toggleLeft()"
    >
      {{ left }}
    </button>
    <button
      class="button--toggle right"
      :class="selected === 'right' ? 'active' : ''"
      @click="toggleRight()"
    >
      {{ right }}
    </button>
  </div>
</template>
<script>
export default {
  name: 'toggle',
  props: {
    selected: {
      type: String,
      default: 'left',
    },
    left: {
      type: String,
      default: '',
    },
    right: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggleLeft() {
      this.$emit('switchToggle', 'left');
    },
    toggleRight() {
      this.$emit('switchToggle', 'right');
    },
  },
};
</script>
<style scoped>
.button--toggle {
  margin: 0;
  padding: 12px 32px;
  border-radius: 0;
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 22px;
  font-weight: 700;
  background: #dadee6;
  color: #727a88;
}
.button--toggle:focus {
  outline: none;
  /* outline: 1px solid #fff; */
  /* outline-offset: -4px; */
}
.left {
  border-radius: 5px 0 0 5px;
}
.right {
  border-radius: 0 5px 5px 0;
}
.active {
  background: #4d48e8;
  color: #fff;
}
</style>
